import React, { useState } from 'react';
import { api, errText } from '@/lib/api';
import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Textarea } from '@/components/ui/textarea';
import { FlaskConical, Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import { AiMeta } from '@/components/ai/AiCommon';

export const AiPlayground = ({ threshold }) => {
  const [subject, setSubject] = useState('');
  const [message, setMessage] = useState('');
  const [res, setRes] = useState(null);
  const [busy, setBusy] = useState(false);

  const run = async () => {
    setBusy(true); setRes(null);
    try { const { data } = await api.post('/ai/test', { subject, message }); setRes(data); }
    catch (e) { toast.error(errText(e)); } finally { setBusy(false); }
  };

  const wouldAuto = res && res.is_simple && res.confidence >= threshold;

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
      <Card className="p-4 space-y-3">
        <p className="text-sm text-[hsl(var(--muted-foreground))]">Simula un ticket para ver cómo respondería el agente con la base de conocimiento actual. No se envía nada al pastor.</p>
        <Input placeholder="Asunto" value={subject} onChange={(e) => setSubject(e.target.value)} data-testid="ai-test-subject" />
        <Textarea rows={7} placeholder="Mensaje del pastor…" value={message} onChange={(e) => setMessage(e.target.value)} data-testid="ai-test-message" />
        <div className="flex justify-end">
          <Button onClick={run} disabled={busy || message.trim().length < 3} data-testid="ai-test-run">
            {busy ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : <FlaskConical className="w-4 h-4 mr-2" />}Probar agente
          </Button>
        </div>
      </Card>
      <Card className="p-4 space-y-3" data-testid="ai-test-result">
        {!res ? (
          <p className="text-sm text-[hsl(var(--muted-foreground))]">{busy ? 'El agente está pensando…' : 'El resultado aparecerá aquí.'}</p>
        ) : (
          <>
            <AiMeta result={res} />
            <div className={`text-xs font-medium ${wouldAuto ? 'text-emerald-300' : 'text-amber-300'}`} data-testid="ai-test-decision">
              {wouldAuto ? 'Se respondería automáticamente' : 'Quedaría como borrador para revisión humana'}
            </div>
            <div className="text-sm whitespace-pre-wrap rounded-md bg-[hsl(var(--muted))]/20 border border-border p-3" data-testid="ai-test-reply">{res.reply}</div>
          </>
        )}
      </Card>
    </div>
  );
};
